import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=62f6d40b&functional=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f6d40b')) {
      api.createRecord('62f6d40b', component.options)
    } else {
      api.rerender('62f6d40b', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=62f6d40b&functional=true&", function () {
      api.rerender('62f6d40b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-material-design-icons/Menu.vue"
export default component.exports